import React, { Component } from "react";

import hero from "../../images/slider/right-img2.png";

class Hero extends Component {
  render() {
    return (
      <section className="wpo-hero-section-1 wpo-hero-section-2" style={{background: "#232f4b"}}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-6 col-lg-6">
              <div className="wpo-hero-section-text">
                <div className="wpo-hero-title">
                  <h2 className="text-white">Conectamos você à oportunidade certa</h2>
                </div>
                <div className="wpo-hero-subtitle">
                  <p  className="text-white">
                    Na Thomas Talent, trabalhamos para alocar profissionais em
                    projetos alinhados aos seus talentos e aspirações. Mais que
                    vagas, oferecemos conexões estratégicas para impulsionar sua
                    carreira.
                  </p>
                </div>
                <div className="btns">
                  <a
                    href="https://wa.me/5511988799979?text=Ol%C3%A1!%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20Thomas%20Talent."
                    target="_blank"
                    rel="noreferrer"
                    className="btn theme-btn"
                  >
                    Fale conosco
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-vec">
          <div className="right-img">
            <div className="r-img">
              <img src={hero} alt="" />
            </div>
            <div className="wpo-happy-client">
              <div className="wpo-happy-client-text">
                <h3>3000+</h3>
                <p>Profissionais Atendidos</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Hero;
